import React, { createContext, useContext, useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { db } from "./firebase";
import sampleArticles from "../api/sampleArticles";

const BlogContext = createContext({ articles: [], loading: true, error: "" });
export const useBlog = () => useContext(BlogContext);

export default function BlogProvider({ children }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const q = query(
          collection(db, "articles"),
          where("status", "==", "published"),
          orderBy("publishedAt", "desc")
        );
        const snap = await getDocs(q);
        if (cancelled) return;

        const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        // Fall back to bundled samples when Firestore has no articles yet,
        // so the UI is functional during setup.
        setArticles(docs.length ? docs : sampleArticles);
      } catch (err) {
        if (cancelled) return;
        setError(err.message || "Failed to load articles");
        setArticles(sampleArticles);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <BlogContext.Provider value={{ articles, loading, error }}>
      {children}
    </BlogContext.Provider>
  );
}
